export default __webpack_public_path__ + "static/media/scoreImage_old.777da286.png";